import { useAsync } from '@tiger/hooks';
import ErrorBox from 'components/ErrorBox';
import Loading from 'components/Loading';
import DocumentItem from '../components/DocumentItem';
import Empty from '../components/Empty';
import store from '../request';

const Statements: React.FC = () => {
    const [{ loading, data, error }, getData] = useAsync(() => store.getStatementList());

    const render = () => {
        if (loading) {
            return <Loading className="mt-5" />;
        }

        if (error) {
            return <ErrorBox error={error} onClick={getData} />;
        }

        return (
            <div className="mt-4">
                {Array.isArray(data) && data.length > 0 ? (
                    data.map((val, index) => <DocumentItem id={val.id} description={val.description} key={index} />)
                ) : (
                    <Empty />
                )}
            </div>
        );
    };

    return (
        <div className="report-statements-root pt-2">
            <div className="text-muted">
                {__('We generate monthly statements for every month you have activities in your account.')}
            </div>
            {render()}
        </div>
    );
};

export default Statements;
